import React, { useEffect } from "react";
import { useLocation, useHistory, useParams } from "react-router-dom";
import { getWorkWiseAuthToken } from "../utils/helper";
import { workwiseServices } from "../api";
import { useCanvas } from "../context/canvasContext";
import SplashScreen from "../components/SplashScreen/SplashScreen";
import { useSplashExit } from "../components/SplashScreen/useSplashExit";
import { useDocument } from "../context/documentInfoContex";


export const AuthenticateDocument = ({ setIsLoading }) => {

  //State from CanvasContext used to store response and set the components according to this data
  const { setDocumentInfo, setIsReadOnly, isTemplateDocument, setIsAuthenticated } = useDocument();


  const history = useHistory();
  const { id } = useParams();
  // Plays the splash's fade-out before actually flipping the parent's loading
  // flag, so the board doesn't just snap into view.
  const { exiting, finishLoading } = useSplashExit(() => setIsLoading(false));
  const handleAuthenticate = async () => {
    try {
      setIsLoading(true);
      const searchParams = new URLSearchParams(document.location.search);
      const isReadOnlyQuery = searchParams.get("readOnly");
      if (!window.navigator.onLine) {
        window.location.pathname = "/no-internet"
        return;
      }
      else {
        if (!!getWorkWiseAuthToken()) {
          const response = await workwiseServices.getDocumentById(id);

          if (response?.status == 200 && response.data?.data?.rightType !== 0 && response.data?.data) {
            //Store the response data in a state using UseState Hook created in CanvasContext

            setDocumentInfo(response.data.data);
            setIsAuthenticated(true);
            finishLoading();

            //Store the response data in a state using UseState Hook created in CanvasContext

            setDocumentInfo(response.data.data);
            if (response.data.data.rightType == 1 || isReadOnlyQuery == "true") {
              setIsReadOnly(true);
            }
          }
          if (response.data?.data?.rightType == 0) {
            // history.push("/unauthorized")
            window.location.pathname = "/unauthorized"
          }
          // history.push("/unauthorized")
        }
        else {
          // history.push("/unauthorized")
          window.location.pathname = "/unauthorized"
        }
      }
    } catch (error) {
      console.log({ error })
      if (error.response?.data?.responseCode === 1008) {
        if (isTemplateDocument) {
          finishLoading();
          setIsAuthenticated(true);
        } else {
          window.location.pathname = "/invalid-document"
        }
      }
      else {
        // history.push("/unauthorized")
        window.location.pathname = "/unauthorized"

      }
    }
  };

  useEffect(() => {
    if (isTemplateDocument !== null) {
      handleAuthenticate()
    }
  }, [isTemplateDocument]);

  return <SplashScreen exiting={exiting} />

}